import { httpClient } from '@/core/api/client/httpClient'

export interface Ubicacion {
  nombre: string
  direccion: string
  mapsUrl: string
}

export interface ContactoInfo {
  telefono: string
  email: string
  sitioWeb: string
  horarioAtencion: string
  ubicaciones: Ubicacion[]
  imageUrl: string | null
}

export interface MensajeContacto {
  nombre: string
  email: string
  asunto: string
  mensaje: string
}

interface BffContactoResponse {
  success: boolean
  data: ContactoInfo
}

interface BffMensajeResponse {
  success: boolean
}

interface BffMediaResponse {
  success: boolean
  data: { name: string; url: string; contentType: string } | null
}

export const contactoService = {
  async obtener(): Promise<ContactoInfo | null> {
    const res = await httpClient.get<BffContactoResponse>('/api/contacto')
    return res.data ?? null
  },

  async obtenerImagenContacto(): Promise<string | null> {
    const res = await httpClient.get<BffMediaResponse>('/api/media/imgcontact.png?canal=web')
    return res.data?.url ?? null
  },

  async enviarMensaje(data: MensajeContacto): Promise<boolean> {
    const res = await httpClient.post<BffMensajeResponse>('/api/contacto/mensaje', data)
    return res.success
  },
}
